import { render } from "./UsaPort.vue?vue&type=template&id=c12fca32&scoped=true"
import script from "./UsaPort.vue?vue&type=script&lang=js"
export * from "./UsaPort.vue?vue&type=script&lang=js"

import "./UsaPort.vue?vue&type=style&index=0&id=c12fca32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12fca32"]])

export default __exports__